/* Original name @uswitch/trustyle.side-nav */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { Themed, useThemeUI } from 'theme-ui'
import { useResponsiveValue } from '@theme-ui/match-media'
import { AccordionPanel, AccordionButton, Accordion, AccordionItem } from '@uswitch/spark.accordion'
import { Palette } from '../../elements/palette'
import { TruCaret } from '@uswitch/spark-icons/tru'

const getVariant = element =>
  `compounds.accordion.variants${'.base'}${element ? `.${element}` : ''}`

const AccordionArrow = ({ isOpen }) => {
  const {
    theme: {
      compounds: { accordion: accordionTheme = {} },
      colors = {},
    },
  } = useThemeUI()
  const iconColor = isOpen
    ? colors[accordionTheme?.variants?.base?.isActive?.caret?.color]
    : colors[accordionTheme?.variants?.base?.caret?.color]
  return (
    <div sx={{ variant: getVariant('caret'), mb: 'none' }}>
      {isOpen ? (
        <TruCaret color={iconColor} size={16} />
      ) : (
        <TruCaret color={iconColor} size={16} sx={{ transform: 'rotate(0.5turn)' }} />
      )}
    </div>
  )
}

const SideNav = ({ internalLinks, additionalLinks = [], className }) => {
  const { theme } = useThemeUI()
  const breakpoints = theme?.breakpoints?.map((breakpoint, i, arr) =>
    arr.length === i + 1 ? 0 : null,
  ) || [null, 0]
  const initiallyOpenedId = useResponsiveValue(breakpoints)

  return (
    <nav className={className}>
      <Accordion expandSingleSection={initiallyOpenedId !== null}>
        <AccordionItem
          open={initiallyOpenedId !== null}
          sx={{
            variant: 'compounds.side-nav.accordion',
          }}
        >
          <AccordionButton
            sx={{
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              '&:focus': {
                bg: 'transparent',
                color: 'black',
                outline: 'none',
                pl: 'unset',
              },
              variant: 'compounds.accordion.variants.base.btn',
            }}
            iconElement={AccordionArrow}
          >
            {internalLinks.title}
          </AccordionButton>
          <AccordionPanel>
            <ul
              sx={{
                variant: 'compounds.side-nav.internalLinkList',
              }}
            >
              {internalLinks?.links?.map(({ text, url, isActive, onClick }) => {
                return (
                  <li
                    key={url}
                    sx={{
                      variant: `compounds.side-nav.internalLinkListItem.${
                        isActive ? 'isActive' : 'base'
                      }`,
                    }}
                    onClick={onClick}
                  >
                    <Palette
                      as={'a'}
                      px={{ color: 'textColor' }}
                      href={url}
                      tabIndex={0}
                      sx={{ borderBottom: 0 }}
                    >
                      {text}
                    </Palette>
                  </li>
                )
              })}
            </ul>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
      {additionalLinks.map(({ title, links = [] }, index) => (
        <Accordion expandSingleSection={initiallyOpenedId !== null}>
          <AccordionItem
            open={initiallyOpenedId !== null}
            sx={{
              variant: 'compounds.side-nav.accordion',
            }}
          >
            <AccordionButton
              sx={{
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                '&:focus': {
                  bg: 'transparent',
                  color: 'black',
                  outline: 'none',
                  pl: 'none',
                },
                variant: 'compounds.accordion.variants.base.btn',
              }}
              iconElement={AccordionArrow}
            >
              {title}
            </AccordionButton>
            <AccordionPanel>
              <ul sx={{ padding: 0, margin: 0 }}>
                {links.map(({ text, url }, index) => (
                  <li
                    key={index}
                    sx={{
                      marginBottom: 0,
                      paddingBottom: 0,
                      variant: 'compounds.side-nav.additionalLink',
                    }}
                  >
                    <Palette
                      as={Themed.a}
                      px={{ color: 'textColor' }}
                      href={url}
                      sx={{ borderBottom: 0 }}
                    >
                      {text}
                    </Palette>
                  </li>
                ))}
              </ul>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      ))}
    </nav>
  )
}
export default SideNav
